import { DOMHelper } from "../Helpers/DOMHelper.js";

export class ShiftFCAModule {

    constructor(shiftDatalayer) {        
        this.shiftDatalayer = shiftDatalayer;
        this.initiatedForms = {};// to remember and not double fire it
        this.enabled = false;
        this.providerName ='pixelmotion';
        this.isfirstPageView = true;
    }

    /**
     * 
     * @returns boolean true if it's enabled 
     */
    init() {        
        this.enabled = 'sd' in window
        // && this.shiftDatalayer.pmdrs.config.accountId == "speeddra2";
        return this.enabled;
    }

    drPageViewEvent ({withClick}) {
        let event = 'drInitialClick'
        console.info("PmDrsShiftFca: pageView + initialClick");        

        sdDataLayer = this._getSdDataLayerObject();
        sdDataLayer.pageType = 'Digital Retailing';                    
        if(withClick){
            sdDataLayer.events = event;
        }
        sd('dataLayer', sdDataLayer);
        sd('send', 'pageview');

        //additional events
        this.drImpressionEvent();
        if(this.isfirstPageView){
            this.drInitialClickEvent();            
        }
        this.isfirstPageView = false;//to not fire again drInitialClick
        return sdDataLayer;
    }

    drImpressionEvent () {
        return this._send('drImpression');
    }

    drInitialClickEvent () {
        return this._send('drInitialClick');
    }

    drTradeInShownEvent () {
        return this._send('drTradeInShown');
    }

    drTradeInStartEvent () {
        return this._send('drTradeInStart');
    }

    drTradeInFinishEvent () {
        if(this.shiftDatalayer.startedSections['tradein']){
            return this._send('drTradeInFinish');        
        }
    }

    drPaymentCalcShownEvent () {
        return this._send('drPaymentCalcShown');        
    }

    drPaymentCalcInteractionEvent () {
        return this._send('drPaymentCalcInteraction');        
    }

    drPaymentCalcFinishEvent () {
        return this._send('drPaymentCalcFinish');        
    }

    drLeadFormShownEvent () {
        return this._send('drLeadFormShown');        
    }

    drLeadFormStartEvent () {
        return this._send('drLeadFormStart');        
    }

    formSubmissionEvent() {//drLeadFormFinishEvent
        return this._send('drLeadFormFinish');        
    }

    drApptSchedShownEvent () {
        return this._send('drApptSchedShown');        
    }

    drApptSchedStartEvent () {
        return this._send('drApptSchedStart');        
    }

    drApptSchedFinishEvent () {
        return this._send('drApptSchedFinish');        
    }

    drPreQShownEvent () {
        return this._send('drPreQShown');        
    }

    drPreQStartEvent () {
        return this._send('drPreQStart');        
    }

    drPreQFinishEvent () {
        return this._send('drPreQFinish');        
    }

    drCreditAppShownEvent ({}) {
        return this._send('drCreditAppShown');
    }

    drCreditAppStartEvent ({}) {
        return this._send('drCreditAppStart');
    }

    drCreditAppFinishEvent ({}) {//not in use
        return this._send('drCreditAppFinish');        
    }

    drFiShownEvent ({accessory}) {
        return this._send('drFiShown');        
    }    

    drFiFinishEvent () {
        return this._send('drFiFinish');        
    }

    drAccessoriesShownEvent () {
        return this._send('drAccessoriesShown');        
    }

    drAddToCartEvent ({accessory}) {
        let event = 'drAddToCart';
        console.info("PmDrsShiftFca: " + event);        
        sdDataLayer = this._getSdDataLayerObject();
        sdDataLayer.addOnName = accessory.title;
        sdDataLayer.addOnType = 'Accessories';
        sdDataLayer.events = event;    
        sd('dataLayer', sdDataLayer);
        sd('send');
        return sdDataLayer;
    }

    drAccessoriesFinishEvent () {
        return this._send('drAccessoriesFinish');        
    }

    drDropSaveEvent () {
        return this._send('drDropSave');        
    }

    drContractShownEvent ({}) {//not in use
        return this._send('drContractShown');        
    }

    drContractStartEvent ({}) {//not in use
        return this._send('drContractStart');        
    }

    drContractFinishEvent ({}) {//not in use
        return this._send('drContractFinish');        
    }

    drOfferAddedEvent ({}) {//not in use
        return this._send('drOfferAdded');        
    }

    chatImpressionEvent({}) {        
        let eventName = 'chatImpression';
        console.info("PmDrsShift: " + eventName);

        sdDataLayer = this._getChatEventBaseObject(eventName);

        sd('dataLayer', sdDataLayer);
        sd('send');
        return sdDataLayer;
    }

    chatClickEvent({}) {
        let eventName = 'chatClick';
        console.info("PmDrsShift: " + eventName);

        sdDataLayer = this._getChatEventBaseObject(eventName);

        sd('dataLayer', sdDataLayer);
        sd('send');
        return sdDataLayer;
    }

    chatMessageEvent({chatMessageContent}) {
        let eventName = 'chatMessage';
        console.info("PmDrsShift: " + eventName);
        sdDataLayer = this._getChatEventBaseObject(eventName);
        sdDataLayer.chatMessageType = 'user';           
        sdDataLayer.chatMessageContent = chatMessageContent;           
        sd('dataLayer', sdDataLayer);
        sdb('send');
        return sdDataLayer;
    }

    chatLeadEvent({chatLeadId}) {
        let eventName = 'chatLead';
        console.info("PmDrsShift: " + eventName);

        sdDataLayer = this._getChatEventBaseObject(eventName);
        sdDataLayer.chatLeadId = chatLeadId;           

        sd('dataLayer', sdDataLayer);
        sd('send');
        return sdDataLayer;       
    }

    chatDrHandoffEvent({}) {//probably won't be used
        return;
        console.info("PmDrsShift: chatDrHandoff");

        sdDataLayer = { 
            chatProfitCenter: 'sales',
            chatType: 'DR',
            chatSessionId: this.shiftDatalayer.getSessionId(),
            chatProvider: this.chatProviderName,
            events: 'chatDrHandoff'
        }

        sdb('send');
        return sdDataLayer;
    }

    chatClosedEvent({}) {
        let eventName = 'chatClosed';
        console.info("PmDrsShift: " + eventName);

        sdDataLayer = this._getChatEventBaseObject(eventName);

        sd('dataLayer', sdDataLayer);
        sd('send');
        return sdDataLayer;
    }

    _getChatEventBaseObject(event){
        let v = this.shiftDatalayer.getVehicleDetails();
        var baseObject = {
            chatProfitCenter: 'sales',
            chatType: 'chat',
            chatSessionId: this.shiftDatalayer.getSessionId(),
            chatProvider: this.providerName,
            events: event
        }
        return baseObject;
    }

    _getSdDataLayerObject(){
        let v = this.shiftDatalayer.getVehicleDetails();
        var baseObject = {
            digRet: {
                dealType: this.shiftDatalayer.getDealType(),
                priceUnlocked: 'True',
                dealId: this.shiftDatalayer.getDealId(),//6664bab6-3062-47d4-b101-6edf6dc07ddb
                provider: this.providerName,
                vehicleYear: v.year,
                vehicleMake: v.make,
                vehicleModel: v.model,
                vehicleVin: v.vin,
                vehicleStatus: v.status
            }
        }
        return baseObject;
    }

    /*Default send, only changes the event name*/
    _send(event){
        console.info("PmDrsShiftFca: " + event);        
        sdDataLayer = this._getSdDataLayerObject();
        sdDataLayer.events = event;    
        sd('dataLayer', sdDataLayer);
        sd('send');
        return sdDataLayer;
    }

}